import { render, staticRenderFns } from "./VerInformes.vue?vue&type=template&id=53163ed4&"
import script from "./VerInformes.vue?vue&type=script&lang=js&"
export * from "./VerInformes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports